export default __webpack_public_path__ + "static/media/COMETA200X200.cadef570.png";